import { render } from "./SharedTeleport.vue?vue&type=template&id=7ec46b48&ts=true"
import script from "./SharedTeleport.vue?vue&type=script&lang=ts"
export * from "./SharedTeleport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_gqlfktcdesk5ooh5mnf2bsua7e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__